import * as React from "react";
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'

import Dashboard from './Pages/Dashboard.js'
import './index.css'
import { Provider } from "react-redux";
import { store } from "./redux/store";
import ThankYou from "./Pages/ThankYou.js";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/thankYou",
    element: <ThankYou />,
  },
  // {
  //   path: "/declaration",
  //   element: <Declaration />,
  // },
  // {
  //   path: "/admin",
  //   element: <Dashboard />,
  // },
  // {
  //   path: "/bookings",
  //   element: <Bookings />,
  // },
  // {
  //   path: "/thankyou",
  //   element: <ThankYou />,
  // },
  // {
  //   path: "/login",
  //   element: <Login />,
  // }
])

createRoot(document.getElementById("root")).render(
  <>
    <Provider store={store()}>
      <RouterProvider router={router} />
      <ToastContainer />
    </Provider>
  </>
);